import { cn } from '@/lib/utils'
import type { IconComponent } from './icon'

export const Wallet: IconComponent = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className={cn(className)}
        >
            <title>Wallet</title>
            <path
                d="M17.9163 5.41667H2.91634C2.4561 5.41667 2.08301 5.04357 2.08301 4.58333V14.5833C2.08301 15.5038 2.8292 16.25 3.74967 16.25H17.9163V5.41667Z"
                fill="#0A0A08"
                fillOpacity="0.2"
            />
            <path
                d="M15.4163 10.8333C15.4163 11.2936 15.0432 11.6667 14.583 11.6667C14.1228 11.6667 13.7497 11.2936 13.7497 10.8333C13.7497 10.3731 14.1228 10 14.583 10C15.0432 10 15.4163 10.3731 15.4163 10.8333Z"
                fill="#0A0A08"
                fillOpacity="0.2"
            />
            <path
                d="M16.2497 5V3.75H2.91634C2.4561 3.75 2.08301 4.1231 2.08301 4.58333M2.08301 4.58333V14.5833C2.08301 15.5038 2.8292 16.25 3.74967 16.25H17.9163V5.41667H2.91634C2.4561 5.41667 2.08301 5.04357 2.08301 4.58333ZM15.4163 10.8333C15.4163 11.2936 15.0432 11.6667 14.583 11.6667C14.1228 11.6667 13.7497 11.2936 13.7497 10.8333C13.7497 10.3731 14.1228 10 14.583 10C15.0432 10 15.4163 10.3731 15.4163 10.8333Z"
                stroke="#0A0A08"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
